<template>
  <Poptip trigger="click" padding="24px">
    <div
      class="scmcc-notice-center-entrance cmsc-cursor-pointer"
      @click="visible(true)"
    >
      <Icon size="25" type="md-notifications-outline" />
      <span
        class="scmcc-notice-center-entrance-badge"
        v-show="badgeNum > 0 || badgeNum == '99+'"
        >{{ badgeNum }}</span
      >
    </div>
    <template v-slot:content>
      <template v-if="wsList.length">
        <div class="scmcc-notice-title">
          <div class="notice-tip">
            您有 <span class="light">{{ badgeNum }}</span> 条新消息
          </div>
          <div
            class="cmsc-font-main theme-font-primary-color"
            @click="entranceNoticeManage"
          >
            查看更多
          </div>
        </div>
        <div class="scmcc-notice-content">
          <div class="notice-list">
            <div
              v-for="(obj, i) in wsList"
              :key="i"
              :class="['item', { 'is-new': obj.isNew }]"
              @click="checkNotice(obj)"
            >
              <span class="title cmsc-ellipsis">{{ obj.title }}</span
              ><span class="time">{{ obj.sendTime }}</span>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="scmcc-notice-empty">
          <span class="tips-text">您暂未收到任何消息</span>
          <span
            class="cmsc-cursor-pointer cmsc-font-main theme-font-primary-color"
            @click="entranceNoticeManage"
            >进入我的消息</span
          >
        </div>
      </template>
    </template>
  </Poptip>
</template>
<script>
export default {
  name: 'noticeCenterEntrance',
  data() {
    return {
    }
  },
  computed: {
    badgeNum() {
      let num = this.$store.state.main.noticeCenter.list.filter(
        item => item.isNew
      ).length
      return num > 99 ? '99+' : num
      // return this.$store.state.main.noticeCenter.list.length
    },
    wsList() {
      let list = this.$store.state.main.noticeCenter.list
      return list.length < 7 ? list : list.slice(0, 8)
    }
  },
  created() {
    //监听事件类型中的彩铃取消发布
    this.$eventBus.on('SCBF.MSG.CANCELPUBLISH', data => {
      this.$store.commit('main/noticeCenter/deleteItem', data.body.id[0])
    })
  },
  methods: {
    visible(value) {
      // this.$store.commit('main/noticeCenter/setVisible', value)
    },
    entranceNoticeManage() {
      document.querySelector('.ivu-poptip-popper').style.display = 'none'
      this.$router.push({ name: 'scbf_ui/informationMain' })
    },
    checkNotice(obj) {
      this.$eventBus.emit('dynamicComponent/call/messageModal', { id: obj.id })
      this.$store.commit('main/noticeCenter/updataNotice', obj.id)
    }
  }
}
</script>
<style lang="stylus">
.scmcc-notice-center-entrance
  position relative

  .title
    font-size 13px

  .scmcc-notice-center-entrance-badge
    position absolute
    top -9px
    right -3px
    height 16px
    min-width 16px
    text-align center
    border-radius 8px
    background red
    color #ffffff
    line-height 16px
    font-size 12px
    padding 0 4px
    transform-origin -10% center
    transform translateX(50%)

.scmcc-notice-title
  display flex
  align-items center
  justify-content space-between
  line-height 1
  padding-bottom 14px
  border-bottom 1px solid #D9E1F6

  .notice-tip
    font-size 14px
    color #90959E

    .light
      color #EB4649

.scmcc-notice-content
  padding-top 24px

  .notice-list
    width 350px
    .item
      display flex
      justify-content space-between
      margin-bottom 16px
      font-size 14px
      padding-left 12px
      color #90959E
      overflow hidden
      
    .title
      flex auto
      width 0
    .time
      flex 0 0 111px
      width 0
    .is-new
      position relative
      color #515A6E

      &:before
        content ''
        width 6px
        height 6px
        border-radius 6px
        background #EB4649
        position absolute
        top 7px
        left 0px

.scmcc-notice-empty
  display flex
  flex-flow column
  justify-content center
  align-items center
  padding 24px 0

  .tips-text
    color #90959E
    margin-bottom 14px
    font-size 14px
</style>

